<script lang="ts">
	import { Responsive } from "responsive"
	import type { Snippet } from "svelte"
	import Sidebar from "./Sidebar.svelte"
	import MobileNavigator from "./mobile-navigation/MobileNavigator.svelte"

	interface Props {
		children: Snippet
	}
	let { children }: Props = $props()

	let isMobile = $derived(Responsive.isMobile)
</script>

{#if isMobile}
	<MobileNavigator>
		{@render children()}
	</MobileNavigator>
{:else}
	<Sidebar>
		{@render children()}
	</Sidebar>
{/if}

<style>
</style>
